import Icon, { IconProps } from '../icon/icon';

type Props = {
    color?: 'yellow' | 'red';
    children: React.ReactNode;
    iconProps: IconProps;
};

export const CardWithIcon = ({ children, color = 'yellow', iconProps }: Props) => {
    const classes = {
        card: `flex items-start w-fit gap-2 relative shadow-lg  shadow-primary-shadow rounded-md  px-2 py-0 border  min-w-0 ${
            color === 'yellow' ? 'border-[#F9B751] bg-[#FFFBEB]' : 'border-[#DC2626] bg-[#FEF2F2]'
        } `,
        icon: color === 'yellow' ? 'text-[#FBBF24]' : 'text-[#DC2626]',
    };
    return (
        <div className={classes.card}>
            <Icon {...iconProps} className={classes.icon} />
            {children}
        </div>
    );
};
